import * as Redux from 'redux'
import * as ReduxObservable from 'redux-observable'
import 'rxjs/add/operator/debounceTime'
import 'rxjs/add/operator/distinctUntilChanged'
import 'rxjs/add/operator/filter'
import 'rxjs/add/operator/map'
import 'rxjs/add/operator/switchMap'
import * as App from '../../app'
import * as RootConstants from '../../constants'
import {ApplicationState} from '../../rootReducer'
import * as Actions from './actions'

export const epic =
  (
    action$: ReduxObservable.ActionsObservable<Redux.Action>,
    store: Redux.Store<ApplicationState>,
    {localStorage}: App.Dependencies,
  ) =>
    action$.ofType(App.CONTENT_INIT)
    .filter(() => Boolean(localStorage.getItem(RootConstants.ACCESS_TOKEN)))
    .map(store.getState)
    .map((state) => {
      return Actions.fetchReferenceData(state.app.selectedCommunity)
    })



// WEBPACK FOOTER //
// ./src/pages/reference/epic.ts